module.exports = "img/flags/TN.58b2065.png";